module.exports = __webpack_public_path__ + "static/media/cono_cenos.fa2f78a2.png";